@if (partCount === 1) {
  <div class="svg-tooth">
    <div>
      <span>{{ generalBase?.label }}</span>
      <svg width="137px" height="187px" viewBox="0 0 137 187" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>Stroke 13</title>
        <g id="--Toothcross" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Group-4-Copy-2" transform="translate(0.000000, 1.000000)" [attr.fill]="generalBase?.color"
            stroke="#979797">
            <g id="Group-3" transform="translate(0.720721, 0.250000)">
              <g id="Group-2" transform="translate(0.004630, 0.000000)">
                <path
                  d="M62.9455187,185 C53.7017142,183.991018 41.6265609,183.043486 29.6670515,181.275289 C14.3943437,179.017469 6.77726373,166.745152 2.56782481,150.47457 C-2.61302309,130.439631 0.65199043,110.965679 6.9700036,91.5650708 C12.4630901,74.6938566 16.8459949,57.4242034 21.3233423,40.2219479 C24.7252011,27.1567178 30.6172591,15.7328185 41.1851866,7.57175763 C56.7431495,-4.4428622 76.8497735,-1.9432028 91.8430085,13.5344662 C101.599501,23.6064482 106.921049,35.7063063 110.068491,49.7725894 C115.22621,72.8324925 122.051129,95.5256731 128.883758,118.145509 C132.967916,131.654771 137.830743,144.710089 134.635116,159.315554 C131.620664,173.076565 122.635131,181.073097 109.019986,181.790683 C94.6280997,182.549898 80.2574145,183.770984 62.9455187,185 Z"
                id="Stroke-13"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>
}

@if (partCount === 2) {
  <div class="svg-tooth two-parts">
    <div class="top-tooth">
      <span>{{ topBase?.label }}</span>
      <svg width="122px" height="97px" viewBox="0 0 122 97" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Group 4 Copy 5</title>
        <defs>
          <path
            d="M87.7749519,13.6807847 C97.8429051,23.8616531 103.334335,36.0923204 106.582254,50.3106715 C109.858332,64.6581772 113.786238,78.8652381 117.966609,93.0010127 L0.044962111,93.0004164 C0.0939625174,92.8519277 0.143145948,92.7034435 0.192509988,92.5549635 C4.96593705,78.1940324 8.92695591,63.5474971 12.8178986,48.8965496 L14.2751672,43.4027866 C14.5179811,42.487308 14.7608838,41.5719495 15.0040564,40.6567798 C18.5145142,27.450304 24.5946669,15.902903 35.4999588,7.65361447 C51.5545851,-4.49089314 72.3030814,-1.9642104 87.7749519,13.6807847 Z"
          id="path-1"></path>
        </defs>
        <g id="--Toothcross" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Group-4-Copy-5" transform="translate(1.000000, 1.000000)">
            <g id="Group-3" transform="translate(0.720721, 0.250000)">
              <g id="Group-2" transform="translate(0.004630, 0.000000)">
                <g id="draw-line-+-draw-line-Mask" transform="translate(0.495370, 0.750000)">
                  <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1"></use>
                  </mask>
                  <use id="Combined-Shape" stroke="#979797" [attr.fill]="topBase?.color" fill="#E4DFD9" xlink:href="#path-1"></use>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <div class="bottom-tooth">
      <span>{{ bottomBase?.label }}</span>
      <svg width="144px" height="98px" viewBox="0 0 144 98" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Group 4 Copy 6</title>
        <defs>
          <path
            d="M132.998169,26.422758 C133.261578,27.2762147 133.528125,28.1278791 133.795585,28.9782456 L134.197181,30.2528839 C134.398042,30.8897781 134.598791,31.5260815 134.798488,32.1620025 L135.1962,33.4333968 C138.692013,44.6606357 141.66399,55.8119755 138.93313,68.037884 C135.822447,81.9476632 126.550065,90.0306435 112.500278,90.7559878 C97.6489528,91.5234101 82.819506,92.7576976 64.9549553,94 C55.4160569,92.9801098 42.9554233,92.0223348 30.6141254,90.2350223 C14.8538604,87.9527926 6.99361719,75.5478022 2.64979857,59.1013217 C-2.65309038,39.0139964 0.618738959,19.4845636 7.03454152,0.0320029728 L124.975894,0.0324102493 C127.584162,8.85132131 130.290579,17.6425061 132.998169,26.422758 Z"
          id="path-2"></path>
        </defs>
        <g id="--Toothcross" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Group-4-Copy-6" transform="translate(1.000000, 1.000000)">
            <g id="Group-3" transform="translate(0.720721, 0.250000)">
              <g id="Group-2" transform="translate(0.004630, 0.000000)">
                <g id="draw-line-+-draw-line-Mask" transform="translate(0.495370, 0.750000)">
                  <mask id="mask-2" fill="white">
                    <use xlink:href="#path-2"></use>
                  </mask>
                  <use id="Combined-Shape" stroke="#979797" [attr.fill]="bottomBase?.color" xlink:href="#path-2"></use>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>
}

@if (partCount === 3) {
  <div class="svg-tooth three-parts">
    <div class="top-tooth">
      <span>{{ topBase?.label }}</span>
      <svg width="90px" height="50px" viewBox="0 0 91 45" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <path
            d="M72.7440601,13.3881476 C81.0927152,21.8307649 86.225535,31.713793 89.5316978,43.0002442 L0.679724254,43.0005815 C0.963820871,41.9292389 1.247992,40.8580454 1.53254087,39.787116 C4.96777459,26.8631317 10.9176383,15.562734 21.5892454,7.48990079 C37.299844,-4.39483126 57.6037297,-1.92219521 72.7440601,13.3881476 Z"
          id="path-1"></path>
        </defs>
        <g id="--Toothcross" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Group-4-Copy-2" transform="translate(-20.220721, 0.000000)">
            <g id="Group-3" transform="translate(0.720721, 0.250000)">
              <g id="Group-2" transform="translate(0.004630, 0.000000)">
                <g id="draw-line-+-draw-line-Mask" transform="translate(19.495370, 0.750000)">
                  <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1"></use>
                  </mask>
                  <use id="Combined-Shape" stroke="#979797" [attr.fill]="topBase?.color" xlink:href="#path-1"></use>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <div class="middle-tooth">
      <span>{{ middleBase?.label }}</span>
      <svg width="138px" height="112px" viewBox="0 0 138 109" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <path
            d="M111.116327,6.96546636 C116.28663,29.651425 123.128201,51.9766082 129.977501,74.2296361 C130.237445,75.0734579 130.500536,75.9154793 130.764506,76.7562052 L131.358966,78.6458647 C134.29567,87.9790482 137.130758,97.1987519 136.743701,106.999481 L3.61344383,107.000107 C3.52533353,106.679858 3.43865374,106.357953 3.35336932,106.034441 C-1.84011932,86.3243938 1.4328605,67.1662353 7.76628898,48.0802319 C13.009278,32.2768452 17.2433377,16.1180974 21.5108394,-0.000420890404 L109.283795,-0.00147222189 C109.966768,2.26343064 110.57377,4.58584597 111.116327,6.96546636 Z"
          id="path-2"></path>
        </defs>
        <g id="--Toothcross" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Group-4-Copy" transform="translate(-1.000000, -43.000000)">
            <g id="Group-3" transform="translate(0.720721, 0.250000)">
              <g id="Group-2" transform="translate(0.004630, 0.000000)">
                <g id="Group-112" transform="translate(0.495370, 18.750000)">
                  <g id="draw-line-+-draw-line-Mask" transform="translate(0.000000, 25.000000)">
                    <mask id="mask-2" fill="white">
                      <use xlink:href="#path-2"></use>
                    </mask>
                    <use id="Combined-Shape" stroke="#979797" [attr.fill]="middleBase?.color"
                    xlink:href="#path-2"></use>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <div class="bottom-tooth">
      <span>{{ bottomBase?.label }}</span>
      <svg width="135px" height="35px" viewBox="0 0 135 34" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <path
            d="M132.742891,6.73205822 C129.721085,20.2699182 120.713628,28.1367761 107.065263,28.8427261 C92.638262,29.5896291 78.2325137,30.7909143 60.8783787,32 C51.6120202,31.0073796 39.5074048,30.0752135 27.5187154,28.3356902 C12.8417521,26.206321 5.21760885,15.0227039 0.894595355,-0.000698732016 L133.693107,-0.00175638401 C133.556229,2.2096913 133.251295,4.45166906 132.742891,6.73205822 Z"
          id="path-3"></path>
        </defs>
        <g id="--Toothcross" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Group-4-Copy" transform="translate(-3.000000, -153.000000)">
            <g id="Group-3" transform="translate(0.720721, 0.250000)">
              <g id="Group-2" transform="translate(0.004630, 0.000000)">
                <g id="Group-112" transform="translate(2.495370, 18.750000)">
                  <g id="draw-line-+-draw-line-Mask" transform="translate(0.000000, 135.000000)">
                    <mask id="mask-2" fill="white">
                      <use xlink:href="#path-3"></use>
                    </mask>
                    <use id="Combined-Shape" stroke="#979797" [attr.fill]="bottomBase?.color"
                    xlink:href="#path-3"></use>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>
}
